import React from 'react';
import { useTranslation } from 'react-i18next';
import { Column, MaskedPhoneText, PhoneButtonText, Row } from '../styled';
import { Icon } from '../../../Icon';
import PhoneWhiteIcon from '../../../../public/static/images/phone_call_white-icon.svg';
import useScreenSize from '../../../../hooks/useScreenSize';

interface DesktopPhoneButtonProps {
  isGallery?: boolean;
}

export const DesktopPhoneButton: React.FC<DesktopPhoneButtonProps> = ({
  isGallery = false
}) => {
  const { t } = useTranslation();
  const { isSmall } = useScreenSize();

  const phoneIcon = (
    <Icon
      IconComponent={PhoneWhiteIcon}
      width={20}
      height={20}
      indent={false}
    />
  );

  const phoneButtonText = (
    <PhoneButtonText tag="body_1" $isGallery={isGallery}>
      {t('pages.current_item.buttons.show_phone')}
    </PhoneButtonText>
  );

  return isGallery ? (
    <Row $isGallery>
      {phoneIcon}
      {!isSmall && phoneButtonText}
    </Row>
  ) : (
    <Column>
      {phoneButtonText}
      <Row>
        {phoneIcon}
        <MaskedPhoneText tag="h2">+994 ••• </MaskedPhoneText>
      </Row>
    </Column>
  );
};
